import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	AppendixSixDTO,
	AppendixSixRequest,
	AppendixSixSaveDTO,
} from '../DTO/forms-management/appendix6';

export const appendix6 = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAppendix6List: builder.query<SuccessResponse<AppendixSixDTO[]>, string>({
			query: (id) => ({
				url: `/web/form/appendix-six/list/${id}`,
				method: 'GET',
			}),
			providesTags: ['Appendix6List'],
		}),
		deleteAppendix6: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/appendix-six/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['Appendix6List'],
		}),
		Appendix6HasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/appendix-six/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getAppendix6Draft: builder.query<
			SuccessResponse<AppendixSixSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/appendix-six/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueAppendix6Draft: builder.mutation<
			SuccessResponse<AppendixSixSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/appendix-six/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editAppendix6: builder.mutation<SuccessResponse<any>, AppendixSixRequest>({
			query: (body) => ({
				url: `/web/form/appendix-six/${body.id}`,
				method: 'PUT',
				body,
			}),
		}),
		createAppendix6: builder.mutation<SuccessResponse<any>, AppendixSixRequest>(
			{
				query: (body) => ({
					url: `/web/form/appendix-six`,
					method: 'POST',
					body,
				}),
			}
		),
		getAppendix6Detail: builder.query<SuccessResponse<AppendixSixDTO>, string>({
			query: (id) => ({
				url: `/web/form/appendix-six/${id}`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetAppendix6ListQuery,
	useDeleteAppendix6Mutation,
	useAppendix6HasDraftQuery,
	useGetAppendix6DraftQuery,
	useContinueAppendix6DraftMutation,
	useEditAppendix6Mutation,
	useCreateAppendix6Mutation,
	useGetAppendix6DetailQuery,
} = appendix6;
